import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { isCompleteGroup, isInProgressGroup, Order } from '~lmo/models/order.model';
import { LmoOrdersService } from '~lmo/services';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-orders',
  styleUrls: ['./lmo-orders.component.scss'],
  templateUrl: './lmo-orders.component.html',
})
export class LmoOrdersComponent implements OnInit {
  public selectedIndex$: Observable<number>;
  constructor(private orderService: LmoOrdersService) {}

  public ngOnInit() {
    this.selectedIndex$ = this.orderService.currentOrder$.pipe(
      distinctUntilChanged((o1: Order, o2: Order) => {
        if (!o2) {
          return false;
        }

        if (!o1 || o1.id !== o2.id) {
          return true;
        }
      }),
      filter((currentOrder) => !!currentOrder),
      map((currentOrder) => {
        if (isCompleteGroup(currentOrder)) {
          return 2;
        } else if (isInProgressGroup(currentOrder)) {
          return 1;
        }
        return 0;
      }),
    );
  }
}
